// extracted by mini-css-extract-plugin
export var avatarContainer = "_63-0";
export var avatarTypingWave = "_63-i";
export var gray = "_63-f";
export var green = "_63-c";
export var icon = "_63-9";
export var image = "_63-1";
export var lg = "_63-6";
export var md = "_63-5";
export var presenceDot = "_63-b";
export var red = "_63-d";
export var sm = "_63-4";
export var status = "_63-a";
export var typingDot = "_63-h";
export var typingPill = "_63-g";
export var xl = "_63-7";
export var xs = "_63-3";
export var xxl = "_63-8";
export var xxs = "_63-2";
export var yellow = "_63-e";